import { createTranslations } from '../../../i18n/types';

const translations = createTranslations({
  ru: {
    title: 'Награды ждут',
    achOne: 'трофей',
    achFew: 'трофея',
    achMany: 'трофеев',
    claim: 'Забрать',
    deposit: 'Пополнить',
    needMoreToClaim: 'Пополни ещё на {{amount}}, чтобы забрать награды за трофеи',
    claimed: 'Награды забраны!',
    xp: 'XP',
    claimFailed: 'Не вышло забрать награды',
    claimFailedHint: 'Награды остались за тобой — попробуй ещё раз',
    notClaimed: 'Награда не получена',
  },
  en: {
    title: 'Rewards waiting',
    achOne: 'ach.',
    achFew: 'ach.',
    achMany: 'ach.',
    claim: 'Claim',
    deposit: 'Top up',
    needMoreToClaim: 'Top up {{amount}} more to claim your achievement rewards',
    claimed: 'Rewards claimed!',
    xp: 'XP',
    claimFailed: "Couldn't claim the rewards",
    claimFailedHint: 'The rewards are still yours — try again',
    notClaimed: 'Reward not claimed',
  },
  uz: {
    title: 'Mukofotlar kutmoqda',
    achOne: 'kubok',
    achFew: 'kubok',
    achMany: 'kubok',
    claim: 'Olish',
    deposit: 'Toʻldirish',
    needMoreToClaim: 'Yutuq mukofotlarini olish uchun yana {{amount}} toʻldir',
    claimed: 'Mukofotlar olindi!',
    xp: 'XP',
    claimFailed: 'Mukofotlarni olishning iloji boʻlmadi',
    claimFailedHint: 'Mukofotlar senda qoldi — yana urinib koʻr',
    notClaimed: 'Mukofot olinmagan',
  },
  fa: {
    title: 'جایزه‌ها منتظرند',
    achOne: 'دستاورد',
    achFew: 'دستاورد',
    achMany: 'دستاورد',
    claim: 'بگیر',
    deposit: 'شارژ کن',
    needMoreToClaim: 'برای گرفتن جایزه دستاوردها {{amount}} دیگر شارژ کن',
    claimed: 'جایزه‌ها گرفته شد!',
    xp: 'XP',
    claimFailed: 'جایزه‌ها گرفته نشد',
    claimFailedHint: 'جایزه‌ها هنوز مال توست — دوباره تلاش کن',
    notClaimed: 'جایزه گرفته نشد',
  },
  pt: {
    title: 'Recompensas esperando',
    achOne: 'troféu',
    achFew: 'troféus',
    achMany: 'troféus',
    claim: 'Pegar',
    deposit: 'Depositar',
    needMoreToClaim: 'Deposite mais {{amount}} para pegar as recompensas dos troféus',
    claimed: 'Recompensas recebidas!',
    xp: 'XP',
    claimFailed: 'Não deu para pegar as recompensas',
    claimFailedHint: 'As recompensas continuam suas — tente de novo',
    notClaimed: 'Recompensa não recebida',
  },
  tr: {
    title: 'Ödüller bekliyor',
    achOne: 'kupa',
    achFew: 'kupa',
    achMany: 'kupa',
    claim: 'Al',
    deposit: 'Yatır',
    needMoreToClaim: 'Kupa ödüllerini almak için {{amount}} daha yatır',
    claimed: 'Ödüller alındı!',
    xp: 'XP',
    claimFailed: 'Ödüller alınamadı',
    claimFailedHint: 'Ödüller hâlâ senin — tekrar dene',
    notClaimed: 'Ödül alınmadı',
  },
  uk: {
    title: 'Нагороди чекають',
    achOne: 'трофей',
    achFew: 'трофеї',
    achMany: 'трофеїв',
    claim: 'Забрати',
    deposit: 'Поповнити',
    needMoreToClaim: 'Поповни ще на {{amount}}, щоб забрати нагороди за трофеї',
    claimed: 'Нагороди забрано!',
    xp: 'XP',
    claimFailed: "Не вийшло забрати нагороди",
    claimFailedHint: 'Нагороди лишились за тобою — спробуй ще раз',
    notClaimed: 'Нагороду не отримано',
  },
  de: {
    title: 'Belohnungen warten',
    achOne: 'Trophäe',
    achFew: 'Trophäen',
    achMany: 'Trophäen',
    claim: 'Abholen',
    deposit: 'Aufladen',
    needMoreToClaim: 'Lade noch {{amount}} auf, um deine Trophäen-Belohnungen abzuholen',
    claimed: 'Belohnungen abgeholt!',
    xp: 'XP',
    claimFailed: "Belohnungen konnten nicht abgeholt werden",
    claimFailedHint: 'Die Belohnungen gehören weiter dir — versuche es noch einmal',
    notClaimed: 'Belohnung nicht abgeholt',
  },
  es: {
    title: 'Recompensas pendientes',
    achOne: 'trofeo',
    achFew: 'trofeos',
    achMany: 'trofeos',
    claim: 'Recoger',
    deposit: 'Recargar',
    needMoreToClaim: 'Recarga {{amount}} más para recoger las recompensas de tus trofeos',
    claimed: '¡Recompensas recogidas!',
    xp: 'XP',
    claimFailed: "No se pudieron recoger las recompensas",
    claimFailedHint: 'Las recompensas siguen siendo tuyas: inténtalo de nuevo',
    notClaimed: 'Recompensa sin recoger',
  },
  pl: {
    title: 'Nagrody czekają',
    achOne: 'trofeum',
    achFew: 'trofea',
    achMany: 'trofeów',
    claim: 'Odbierz',
    deposit: 'Doładuj',
    needMoreToClaim: 'Doładuj jeszcze o {{amount}}, żeby odebrać nagrody za trofea',
    claimed: 'Nagrody odebrane!',
    xp: 'XP',
    claimFailed: "Nie udało się odebrać nagród",
    claimFailedHint: 'Nagrody nadal są twoje — spróbuj jeszcze raz',
    notClaimed: 'Nagroda nieodebrana',
  },
});

export default translations;
